import { Box, RadioGroup, useMediaQuery, useTheme } from "@mui/material";
import { IconLock, IconUsers } from "@tabler/icons-react";
import { useState } from "react";
import RadioButtonOption from "../../../../../../components/forms/RadioButtonOption";
import Input from "../../../../../../components/ui/Input";
import Select from "../../../../../../components/ui/Select";
import { GAME_VISIBILITY, SPORTS } from "../../../../../../constants/game";

const GameTypeSelection = ({ gameData, onGameTypeChange, onSportChange }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const sportOptions = [
    ...SPORTS.map((sport) => ({ value: sport, label: sport })),
    { value: "Other", label: "Other" },
  ];

  const [showCustomSport, setShowCustomSport] = useState(
    gameData.sport && !SPORTS.includes(gameData.sport),
  );
  const [customSportValue, setCustomSportValue] = useState(
    gameData.sport && !SPORTS.includes(gameData.sport) ? gameData.sport : "",
  );

  const handleSportChange = (event) => {
    const value = event.target.value;
    if (value === "Other") {
      setShowCustomSport(true);
      setCustomSportValue("");
      onSportChange("Other");
    } else {
      setShowCustomSport(false);
      setCustomSportValue("");
      onSportChange(value);
    }
  };

  const handleCustomSportChange = (event) => {
    const value = event.target.value;
    setCustomSportValue(value);
    onSportChange(value);
  };

  return (
    <Box>
      <RadioGroup value={gameData.visibility} onChange={onGameTypeChange}>
        <Box
          sx={{
            display: "flex",
            flexDirection: isDesktop ? "row" : "column",
            gap: 2,
          }}
        >
          <Box sx={{ flex: isDesktop ? 1 : "none" }}>
            <RadioButtonOption
              value={GAME_VISIBILITY.PRIVATE}
              selectedValue={gameData.visibility}
              icon={<IconLock size={16} />}
              title="Private game"
              description="Only people with the link can join. Your game will not be visible in upcoming games."
              onClick={(value) => onGameTypeChange({ target: { value } })}
            />
          </Box>

          <Box sx={{ flex: isDesktop ? 1 : "none" }}>
            <RadioButtonOption
              value={GAME_VISIBILITY.PUBLIC}
              selectedValue={gameData.visibility}
              icon={<IconUsers size={16} />}
              title="Public game"
              description="Your game will be visible in upcoming games for anyone to join."
              onClick={(value) => onGameTypeChange({ target: { value } })}
            />
          </Box>
        </Box>
      </RadioGroup>

      <Box sx={{ mt: 2 }}>
        <Select
          label="Sport"
          placeholder="Select sport"
          value={showCustomSport ? "Other" : gameData.sport}
          onChange={handleSportChange}
          options={sportOptions}
        />
        {showCustomSport && (
          <Box sx={{ mt: 2 }}>
            <Input
              label="Enter sport name"
              placeholder="Enter sport name"
              value={customSportValue}
              onChange={handleCustomSportChange}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default GameTypeSelection;
